import React from 'react';
import { useContext } from 'react';
import TranslationsContext from '../TranslationsContext';

const Confirmation = ({ subscriptionProducts, depositedData, setConsentIsClicked, consentIsClicked, tableType, formatMoney }) => {
	const t = useContext(TranslationsContext);
	return (
		<div className="column small-12 flex-container flex-dir-column align-middle confirmation-wrapper">
			<div className="columns flex-container flex-dir-column confirmation-wrapper__box" style={{ maxWidth: '800px' }}>
				<h3 className="h5 flex-container flex-dir-row align-middle">
					<span className="field__number">4</span>
					{depositedData.length > 1 ? t('confirm_subscriptions') : t('confirm_subscription_title')}
				</h3>
				{depositedData.map((data, index) => {
					return (
						<table className={tableType} key={index}>
							<tbody>
								<tr className="is-hidden-desktop">
									<td className="flex-container flex-dir-column" colSpan={2} style={{ display: 'table-cell', textAlign: 'center' }}>
										<span className="h6 flex-container">
											{t('subscribed_to_products_bottles', {
												count: data.products.length,
												bottles: data.products
													.map((el) =>
														data.subscription.products[el] ? parseInt(data.subscription.products[el].custom_bottles) : 0,
													)
													.reduce((a, b) => parseInt(a) + parseInt(b), 0),
											})}
										</span>
										<div className="flex-container flex-dir-row flex-wrap align-spaced">
											{data.products.map((el, index) => {
												if (data.subscription.products[el]) {
													return (
														<div key={index} className="confirmation-wrapper__product">
															<img src={subscriptionProducts[el].fetchData.images[0]} />
															<span className="badge">{data.subscription.products[el].custom_bottles}</span>
															<span className="confirmation-wrapper__product-title">
																{subscriptionProducts[el].fetchData.title}
															</span>
														</div>
													);
												} else {
													return '';
												}
											})}
										</div>
									</td>
								</tr>

								<tr className="is-hidden-mobile">
									<td>
										<span className="h6">
											{t('subscribed_to_products_bottles', {
												count: data.products.length,
												bottles: data.products
													.map((el) =>
														data.subscription.products[el] ? parseInt(data.subscription.products[el].custom_bottles) : 0,
													)
													.reduce((a, b) => parseInt(a) + parseInt(b), 0),
											})}
										</span>
									</td>
									<td>
										<div className="flex-container flex-dir-row flex-wrap align-spaced">
											{data.products.map((el, index) => {
												if (data.subscription.products[el]) {
													return (
														<div key={index} className="confirmation-wrapper__product">
															<img src={subscriptionProducts[el].fetchData.images[0]} />
															<span className="badge">{data.subscription.products[el].custom_bottles}</span>
															<span className="confirmation-wrapper__product-title">
																{subscriptionProducts[el].fetchData.title}
															</span>
														</div>
													);
												} else {
													return '';
												}
											})}
										</div>
									</td>
								</tr>
								<tr>
									<td>
										<span className="h6">{t('subscription_plan')}</span>
									</td>
									<td>{data.subscription.title}</td>
								</tr>
								<tr>
									<td>
										<span className="h6">{t('payment_frequency')}</span>
									</td>
									<td>{t('once_every_days', { days: data.subscription.days })}</td>
								</tr>
								<tr>
									<td>
										<span className="h6">{t('original_price')}</span>
									</td>
									<td className="original-price-cell">
										{formatMoney(data.subscription_total_price / 100)}
									</td>
								</tr>
								<tr>
									<td>
										<span className="h6">{t('your_savings')}</span>
									</td>
									<td>
										{formatMoney(
											(data.subscription_total_price - (data.subscription_total_price * (100 - data.discount)) / 100) /
												100
										)}{' '}
										(-{data.products.length * 5}%)
									</td>
								</tr>
								<tr>
									<td>
										<span className="h6">{t('subscription_price')}</span>
									</td>
									<td>
										{formatMoney((data.subscription_total_price * (100 - data.discount)) / 100 / 100)}
									</td>
								</tr>
							</tbody>
						</table>
					);
				})}
			</div>
			<div className="columns flex-container flex-dir-row confirmation-wrapper__box" style={{ maxWidth: '800px' }}>
				<input
					type="checkbox"
					id="consent"
					name="consent"
					value={consentIsClicked}
					onChange={(e) => {
						setConsentIsClicked(e.target.checked);
					}}
				/>
				<label style={{ fontSize: '14px' }} htmlFor="consent">
					{t('consent_label')}
				</label>
			</div>
		</div>
	);
};

export default Confirmation;
